import axios from 'axios';
import { getToken, setToken, getRefreshToken, setRefreshToken, clearAllTokens } from './authStorage';

const apiUrl = process.env.REACT_APP_API_URL;

// Debug temporal - remover después
console.log('🔍 Debug axiosConfig:');
console.log('   REACT_APP_API_URL:', process.env.REACT_APP_API_URL);
console.log('   apiUrl:', apiUrl);
console.log('   NODE_ENV:', process.env.NODE_ENV);

const axiosInstance = axios.create({
  baseURL: apiUrl,
});

// Interceptor de solicitud para incluir el token de acceso
axiosInstance.interceptors.request.use(
  async (config) => {
    const token = await getToken(); // Espera la promesa de getToken
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Interceptor de respuesta para manejar el refresh token
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // Si el token ha expirado y no se ha intentado el refresh aún
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true; // Evita bucles de reintentos

      const refreshToken = await getRefreshToken(); // Espera la promesa de getRefreshToken
      if (!refreshToken) {
        // Limpiar tokens y redirigir al login si el refresh token no está disponible
        await clearAllTokens();
        window.location.href = '/';
        return Promise.reject(error);
      }

      try {
        // Pide un nuevo access token usando el refresh token
        // Usar axios directo para evitar el interceptor de autorización
        const { data } = await axios.post(`${apiUrl}/api/refresh-token`, { refreshToken });

        // Verificar que la respuesta tenga la estructura correcta
        if (data.message === 'Token refreshed successfully' && data.accessToken && data.refreshToken) {
          // Guardar ambos tokens (access y refresh)
          await setToken(data.accessToken);
          await setRefreshToken(data.refreshToken);
          
          // Actualizar el header de la solicitud original
          originalRequest.headers['Authorization'] = `Bearer ${data.accessToken}`;

          // Reintentar la solicitud original con el nuevo token
          return axiosInstance(originalRequest);
        } else {
          throw new Error('Invalid refresh response structure');
        }
      } catch (refreshError) {
        console.error('Refresh token failed:', refreshError);
        // En caso de que el refresh token también falle, limpiar tokens y redirigir al login
        await clearAllTokens();
        window.location.href = '/';
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
